import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { PAGE_TITLE_KEYS } from '../../constants/menu';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';
import NotificationBell from '../NotificationBell/NotificationBell';
import Logo from '../Logo/Logo';
import UserProfile from '../UserProfile/UserProfile';
import './Header.css';

function Header() {
    const { pathname } = useLocation();
    const { t } = useTranslation('common');
    const currentTitle = t(PAGE_TITLE_KEYS[pathname] || 'nav.home');

    return (
        <header className="app-header">
            <div className="app-header__trail">
                <Link to="/home" aria-label={t('a11y.home')}>
                    <Logo />
                </Link>
                <span className="app-header__separator">/</span>
                <span className="app-header__current">{currentTitle}</span>
            </div>

            <div className="app-header__actions">
                <NotificationBell />
                <span className="app-header__divider" aria-hidden />
                <LanguageSwitcher />
                <span className="app-header__divider" aria-hidden />
                <UserProfile />
            </div>
        </header>
    );
}

export default Header;
